import Config from "@/const/Config";

export class Logger {
    /**
     *
     * @param message
     * @param optionnalParams
     */
    static log(message: string | null, optionnalParams: any = null) {
      console.log(message, optionnalParams)
    }
    /**
     *
     * @param message
     * @param optionnalParams
     */
    static debug(message: string | null, optionnalParams: any = null) {
      if(!Config.APP_DEBUG){
        return
      }

      console.log(message, optionnalParams)
    }
    /**
     *
     * @param message
     * @param optionnalParams
     */
    static error(message: string | null, optionnalParams: any = null) {
      console.log(message, optionnalParams)
    }
  }
  